import { NavLink, Outlet } from "react-router-dom";
import AppBreadcrumbs from "components/common/AppBreadcrumbs";
import SettingsAccountSummary from "pages/settings/SettingsAccountSummary";

const NAV = [
  { to: "/settings/profile", label: "Profile" },
  { to: "/settings/image", label: "Change image" },
  { to: "/settings/password", label: "Change password" },
];

function navLinkClassName({ isActive }) {
  return [
    "block w-full border-b border-slate-200 py-3.5 text-left text-base font-medium transition-colors",
    isActive ? "text-brand-900" : "text-text-700 hover:text-brand-900",
  ].join(" ");
}

export default function SettingsLayout() {
  return (
    <div className="space-y-4">
      <AppBreadcrumbs
        items={[
          { label: "Settings", path: "/settings/profile" },
          { label: "Account" },
        ]}
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,220px)_1fr] lg:gap-10">
        <aside className="border-b border-slate-200 pb-6 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-8">
          <nav aria-label="Settings sections">
            {NAV.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={navLinkClassName}
                end={to === "/settings/profile"}
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="min-w-0 space-y-6">
          <SettingsAccountSummary />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
